module.exports = __webpack_public_path__ + "img/profile.77f5794e.jpg";